import { useContext } from 'react';
import {
  CorporateFieldsContext,
  CorporateFieldsContextType,
} from 'src/components/enterprise/features/Corporate/components/CorporateFieldsData/CorporateFieldsContext';

export const useCorporateFieldsContext = (): CorporateFieldsContextType => {
  const context = useContext(CorporateFieldsContext);
  if (!context) {
    throw new Error(
      'useCorporateFieldsContext must be used within a CorporateFieldsProvider'
    );
  }
  return context;
};
